import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#button-style" }),
  /*#__PURE__*/_createTextVNode(" Button style ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Checkbox with button styles. ", -1)
const _hoisted_4 = { class: "rounded border p-10" }
const _hoisted_5 = { style: {"margin-top":"20px"} }
const _hoisted_6 = { style: {"margin-top":"20px"} }
const _hoisted_7 = { style: {"margin-top":"20px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_checkbox_button = _resolveComponent("el-checkbox-button")
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode("div", null, [
        _createVNode(_component_el_checkbox_group, {
          modelValue: _ctx.checkboxGroup1,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.checkboxGroup1 = $event))
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cities, (city) => {
              return (_openBlock(), _createBlock(_component_el_checkbox_button, {
                label: city,
                key: city
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(city), 1)
                ]),
                _: 2
              }, 1032, ["label"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_el_checkbox_group, {
          modelValue: _ctx.checkboxGroup2,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.checkboxGroup2 = $event)),
          size: "medium"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cities, (city) => {
              return (_openBlock(), _createBlock(_component_el_checkbox_button, {
                label: city,
                key: city
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(city), 1)
                ]),
                _: 2
              }, 1032, ["label"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode(_component_el_checkbox_group, {
          modelValue: _ctx.checkboxGroup3,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.checkboxGroup3 = $event)),
          size: "small"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cities, (city) => {
              return (_openBlock(), _createBlock(_component_el_checkbox_button, {
                label: city,
                disabled: city === 'Beijing',
                key: city
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(city), 1)
                ]),
                _: 2
              }, 1032, ["label", "disabled"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode(_component_el_checkbox_group, {
          modelValue: _ctx.checkboxGroup4,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.checkboxGroup4 = $event)),
          size: "mini",
          disabled: ""
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cities, (city) => {
              return (_openBlock(), _createBlock(_component_el_checkbox_button, {
                label: city,
                key: city
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(city), 1)
                ]),
                _: 2
              }, 1032, ["label"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code5), 1)
        ]),
        _: 1
      })
    ])
  ]))
}